import { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useStore from "../store/useStore";
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  LogoutOutlined,
  DatabaseOutlined,
  BarcodeOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
import { Button, Menu, Dropdown, Space } from "antd";

import { ICONS } from "../assets/index";

// import {logonav} from "../assets/images/logonav.png"

import logonav from "/src/assets/images/logonav.png";
import glast from "/src/assets/images/glast.jpeg";

const Navbar = ({ collapsed, toggleCollapsed }) => {
  const { logout, isLoggedIn } = useStore();
  const { navigate } = useNavigate();
  const { i18n } = useTranslation();
  const [current, setCurrent] = useState("ID");

  const changeLanguage = (e) => {
    i18n.changeLanguage(e);
    setCurrent(e.toUpperCase());

    console.log("bahsaa ke ubah", e);
  };

  const handleLogout = () => {
    console.log(isLoggedIn);
    logout();
  };

  const fullMenuItems = [
    {
      key: "1",
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    // {
    //   key: "99",
    //   icon: <AppstoreOutlined />,
    //   label: <Link to="/audit-trail">Audit Trail</Link>,
    // },
    {
      key: "2",
      label: "Master Data",
      icon: <DatabaseOutlined />,
      children: [
        { key: "21", label: <Link to="/master-acc">Master Regional</Link> },
        { key: "22", label: <Link to="/master-branch">Master Branch</Link> },
        { key: "23", label: <Link to="/master-emp">Master Employee</Link> },
        {
          key: "24",
          label: <Link to="/master-acc">Master Group Showroom</Link>,
        },
        {
          key: "25",
          label: <Link to="/master-dealer">Master Showroom / Dealer</Link>,
        },
        { key: "26", label: <Link to="/master-piutang">Master Brand</Link> },
        { key: "27", label: <Link to="/master-anggota">Master Type</Link> },
        { key: "28", label: <Link to="/master-anggota">Master Unit</Link> },
        { key: "29", label: <Link to="/master-anggota">Master Asset</Link> },
      ],
    },
    {
      key: "3",
      icon: <AppstoreOutlined />,
      label: "Application Order",
      children: [
        { key: "31", label: <Link to="/orderlist">Order List</Link> },
        { key: "32", label: <Link to="/orderlist-DF">Order List DF</Link> },
      ],
    },
    {
      key: "4",
      icon: <AppstoreOutlined />,
      label: "Credit Process",
      children: [
        { key: "41", label: <Link to="/approval">Approval Task</Link> },
        { key: "42", label: <Link to="/inquiry">Application Inquiry</Link> },
      ],
    },
    { key: "5", icon: <AppstoreOutlined />, label: "Document Printing" },
    {
      key: "6",
      icon: <AppstoreOutlined />,
      label: <Link to="/doc-check">Document Checking & Disbursement</Link>,
    },
    { key: "7", icon: <AppstoreOutlined />, label: "Insurance Submission" },
    { key: "8", icon: <AppstoreOutlined />, label: "Fidusia Submission" },
    {
      key: "9",
      label: "Report",
      icon: <FolderOpenOutlined />,
      children: [
        {
          key: "81",
          label: <Link to="/report/jurnal">Application All Status</Link>,
        },
        { key: "82", label: <Link to="/report/buku-besar"></Link> },
        {
          key: "83",
          label: <Link to="/report/neraca-saldo">Neraca Saldo</Link>,
        },
        { key: "84", label: <Link to="/report/shu">Sisa Hasil Usaha</Link> },
        { key: "85", label: <Link to="/report/neraca">Necara</Link> },
      ],
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <Link to={"/login"} onClick={() => logout()}>
          Logout
        </Link>
      ),
    },
  ];

  const cmoMenu = [
    {
      key: "dashboard",
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <Link to="/login" onClick={() => logout()}>
          Logout
        </Link>
      ),
    },
  ];

  const viewerMenu = [
    {
      key: "dashboard",
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: "3",
      icon: <AppstoreOutlined />,
      label: "Application Order",
      children: [
        { key: "31", label: <Link to="/orderlist">Order List</Link> },
        // { key: "32", label: <Link to="/orderlist-DF">Order List DF</Link> },
      ],
    },
    {
      key: "4",
      icon: <AppstoreOutlined />,
      label: "Credit Process",
      children: [
        { key: "41", label: <Link to="/approval">Approval Task</Link> },
        { key: "42", label: <Link to="/inquiry">Application Inquiry</Link> },
      ],
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <Link to="/login" onClick={() => logout()}>
          Logout
        </Link>
      ),
    },
  ];

  const restrictedMenu = [
    {
      key: "1",
      icon: <AppstoreOutlined />,
      label: <Link to="/dashboard">Dashboard</Link>,
    },
    {
      key: "3",
      icon: <AppstoreOutlined />,
      label: "Application Order",
      children: [
        { key: "31", label: <Link to="/orderlist">Order List</Link> },
        { key: "32", label: <Link to="/orderlist-DF">Order List DF</Link> },
      ],
    },
    {
      key: "4",
      icon: <AppstoreOutlined />,
      label: "Credit Process",
      children: [
        { key: "41", label: <Link to="/approval">Approval Task</Link> },
        { key: "42", label: <Link to="/inquiry">Application Inquiry</Link> },
      ],
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: (
        <Link to={"/login"} onClick={() => logout()}>
          Logout
        </Link>
      ),
    },
  ];

  const itemsMenu = useMemo(() => {
    const role = localStorage.getItem("rolenya");

    console.log('ROLE NYA APAA ==>', role)

    if (role === "cmo") {
      return cmoMenu;
    }

    if (role === "admin_operation" ) {
      return restrictedMenu;
    }

    if (role === 'viewer'){
      return viewerMenu;
    }

    if (role === "admin_df") {
      return [
        {
          key: "1",
          icon: <AppstoreOutlined />,
          label: <Link to="/dashboard">Dashboard</Link>,
        },
        {
          key: "3",
          icon: <AppstoreOutlined />,
          label: "Application Order",
          children: [
            { key: "32", label: <Link to="/orderlist-DF">Order List DF</Link> },
          ],
        },
        {
          key: "logout",
          icon: <LogoutOutlined />,
          label: (
            <Link to={"/login"} onClick={() => logout()}>
              Logout
            </Link>
          ),
        },
      ];
    }

    return fullMenuItems;
  }, [logout]);

  const items = [
    {
      key: "English",
      label: (
        <button
          onClick={() => changeLanguage("en")}
          className="flex gap-2 items-center w-full"
        >
          <img src="./EN-flag.svg" alt="Eng" className="w-5" /> English
        </button>
      ),
    },
    {
      key: "Bahasa Indonesia",
      label: (
        <button
          onClick={() => changeLanguage("id")}
          className="flex gap-2 items-center w-full"
        >
          <img src="./ID-flag.svg" alt="Indo" className="w-5" />
          Bahasa Indonesia
        </button>
      ),
    },
  ];

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(itemsMenu);

  const [stateOpenKeys, setStateOpenKeys] = useState(["1"]);
  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    // open
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          // remove repeat key
          .filter((_, index) => index !== repeatIndex)
          // remove current level all child
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  return (
    <div
      className=""
      // className={`fixed h-screen bg-slate-50 ${
      //   collapsed ? "w-20" : "w-64"
      // } transition-width`}
    >
      <div
        className={`flex items-center  gap-2 px-4 py-3 mb-4 ${
          collapsed ? "justify-center" : "justify-start"
        }`}
      >
        {!collapsed && (
          <div>
            {/* <img src={glast} alt="Logo" className="left-10 w-12 h-12 object-contain" /> */}
            <div className="flex justify-start items-center h-20">
              <img
                src={glast}
                alt="Logo"
                className="ml-4 w-auto h-auto max-w-[100px] max-h-[100px] object-contain"
              />
            </div>

            {/* <span className="text-xs text-[#4d0702] font-semibold tracking-widest block leading-tight">
              G-LAST
            </span> */}
            {/* <span className="text-sm text-[#4d0702] font-bold tracking-wide leading-tight whitespace-nowrap">
              GRATAMA FINANCE
            </span> */}
          </div>
        )}

        <div className="ml-auto">
          <button onClick={toggleCollapsed}>
            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          </button>
        </div>
      </div>

      <Menu
        defaultSelectedKeys={["1"]}
        // defaultOpenKeys={["master"]}
        openKeys={stateOpenKeys}
        onOpenChange={onOpenChange}
        mode="inline"
        inlineCollapsed={collapsed}
        items={itemsMenu}
        className="bg-slate-50"
      />

      <div className="w-full absolute bottom-5 px-4">
        <Dropdown
          menu={{
            items,
          }}
          placement="top"
        >
          <Button className="w-full">
            {collapsed ? current : "Pilih Bahasa"}
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};
export default Navbar;
